import React, { useState } from "react";

import LockIcon from "@mui/icons-material/Lock";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { IconButton, InputAdornment } from "@mui/material";

import TextField, { TextFieldProps } from "../components/TextField";

export type PasswordProps = TextFieldProps;

const PasswordField = (props: PasswordProps) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleClick = () => setShowPassword(!showPassword);

  const startAdornment = (
    <InputAdornment position="start">
      <LockIcon sx={{ fill: "#E0E0E0" }} />
    </InputAdornment>
  );
  const endAdornment = (
    <InputAdornment position="end">
      <IconButton
        aria-label="toggle password visibility"
        onClick={handleClick}
        edge="end"
      >
        {showPassword ? (
          <Visibility sx={{ fill: "#C4C4C4" }} />
        ) : (
          <VisibilityOff sx={{ fill: "#C4C4C4" }} />
        )}
      </IconButton>
    </InputAdornment>
  );
  return (
    <TextField
      data-test-id="auth-password-input"
      label={props.label || "Password"}
      name={props.name || "password"}
      type={showPassword ? "text" : "password"}
      helperText={props.helperText}
      error={props.error}
      InputProps={{ startAdornment, endAdornment, ...props.InputProps }}
    />
  );
};

export default PasswordField;
